import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSuggestedCallReport extends Layout {
    excludabletextboxAssignUsers: ExcludableTextbox;
    sourceSuggestedCall: DataSource;
    switchSource: Switch;
    textboxCutoffDate: Textbox;
}
